/*
    EG Megamenu Image
    © 2022 EcomGraduates
    https://wwww.ecomgraduates.com
*/

document.querySelectorAll('.mega-menu__link').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div
            style="max-width: 100%; background-color: #f5f5f5; margin-bottom: .4rem;"
            
            >
            <img
                class="megamenu-image" 
                src="${img}"
                alt=""
                width=""
                height=""
                style="max-width: 100%; height: auto; margin-bottom: .4rem; mix-blend-mode: multiply;">
            </div>
            <div style="text-align: left">
                ${title} 🡢
            </div>
        `
        elem.closest('.mega-menu__list').style.gridTemplateColumns = 'repeat(5, minmax(0, 1fr))'
    }
  
    function removeCondensedClassFromUlMegaMenu() {
        // Select all ul elements
        const ulElements = document.querySelectorAll('ul.mega-menu__list');
    
        // Iterate through each ul element
        ulElements.forEach(ul => {
            // Check if any li child contains an img element
            const hasImage = Array.from(ul.children).some(li => li.querySelector('img.megamenu-image'));
    
            // If an img is found in a li, remove the class 'mega-menu__list--condensed' from the ul
            if (hasImage) {
                ul.classList.remove('mega-menu__list--condensed');
            }
        });
    }
    
    // Run the function
    removeCondensedClassFromUlMegaMenu();
})

document.querySelectorAll('.menu-drawer__menu-item').forEach(elem => {
    if (elem.textContent.includes('|')) {
        const title = elem.textContent.split('|')[0].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        const img = elem.textContent.split('|')[1].replace(/[\n\r]+|[\s]{2,}/g, ' ').trim()
        elem.innerHTML = `
            <div>
                <img
                    class="megamenu-image" 
                    src="${img}"
                    alt=""
                    width=""
                    height=""
                    style="max-width: 100%; height: auto; margin-bottom: .4rem;">
                <div style="text-align: left">
                    ${title}
                </div>
            </div>
        `
    }
})
